let locationsApiLoaded = false;
let service;
const locationApiKey = 'AIzaSyAWCMKF2Bt7egYMoYYO-4P7v9DtWFuGLDk';

if (!locationsApiLoaded) {
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${locationApiKey}&libraries=places`;
  script.async = true;
  script.defer = true;
  script.onload = () => {
    locationsApiLoaded = true;
    service = new window.google.maps.places.AutocompleteService();
  };
  document.body.appendChild(script);
}

const getLocations = query =>
  new Promise((resolve, reject) => {
    if (typeof service === 'undefined') {
      reject();
    } else if (query) {
      service.getPlacePredictions(
        {
          input: query,
          componentRestrictions: {
            country: 'IN',
          },
        },
        (predictions, status) => {
          if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
            reject();
          } else {
            resolve(predictions.map(prediction => ({
              ...prediction,
              name: prediction.description,
            })));
          }
        });
    }
  });

export default getLocations;



// WEBPACK FOOTER //
// ./src/utils/locations.js